<template>
  <div class="capture-person-page">
    <v-img alt="Logo" class="shrink mr-2 app capture-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner capture-panel">
      <v-container>
        <v-card elevation="0" class="capture-card align-center pa-4 mx-auto">
          <header class="capture-header">
            <h1>{{ "กรุณามองกล้อง" }}</h1>
            <p>{{ "PLEASE LOOK AT THE CAMERA" }}</p>
            <span>{{ captureStatus }}</span>
            <v-divider class="capture-divider"></v-divider>
          </header>

          <div class="camera-stage">
            <div class="camera-container">
              <video v-show="!isPhotoTaken" ref="camera" autoplay playsinline></video>
              <div class="person-frame">
                <div class="person-head"></div>
                <div class="person-shoulders"></div>
              </div>
            </div>
          </div>

          <div class="capture-actions">
            <v-card elevation="0" class="box white--text text-capitalize capture-button" color="#344054"
              @click="BackToMain()" style="line-height:1.1">
              <span>{{ "ย้อนกลับ" }}</span>
              <small>{{ "BACK" }}</small>
            </v-card>

            <v-card id="downloadPhoto" elevation="0" class="box white--text text-capitalize capture-button"
              color="#344054" :download="PictureName" @click="takePhotobast64()" style="line-height:1.1">
              <span>{{ "ถ่ายรูป" }}</span>
              <small>{{ "TAKE NOW" }}</small>
            </v-card>
          </div>
        </v-card>
      </v-container>
    </v-sheet>
  </div>
</template>
<script>
// import axios from "axios";
import enurl from "@/api/environment";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "CapturePerson",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      isPhotoTaken: false,
      download: false,
      LoadingDialog: false,
      PictureName: "PersonID.jpg",
      dataParam: [],
      imageParam: "",
      photoBase64: "",
      logoimage: "",
      captureStatus: "*ระบบจะถ่ายอัตโนมัติเมื่อพบใบหน้าในกรอบ",
      autoCaptureTimer: null,
      autoCaptureCanvas: null,
      faceDetector: null,
      isAutoCapturing: false,
      isDetectingPerson: false,
    };
  },

  mounted: function () {
    let self = this;
    self.createCameraElement();

   
    self.dataParam = self.$route.params.data;
    self.logoimage = require("@/assets/OneBangkokLogo.png");
    //  console.log(self.dataParam);

    // setInterval(() => {
    //   self.getCurrentDate();
    // }, 1000);
  },

  beforeDestroy() {
    this.stopAutoCapture();
    this.stopCameraStream();
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.camera.srcObject = stream;
          const track = stream.getVideoTracks()[0];

          if ("ImageCapture" in window) {
            this.imageCapture = new ImageCapture(track);
          }

          if ("FaceDetector" in window) {
            this.faceDetector = new window.FaceDetector({
              fastMode: true,
              maxDetectedFaces: 1,
            });
          }

          this.$refs.camera.onloadedmetadata = () => {
            this.startAutoCapture();
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    stopCameraStream() {
      this.stopAutoCapture();

      if (this.$refs.camera && this.$refs.camera.srcObject != null) {
        let tracks = this.$refs.camera.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }


    },

      takePhoto() {
      let self = this;
      self.isShotPhoto = true;
      self.LoadingDialog = true;
      const FLASH_TIMEOUT = 50;


      const videoElement = self.$refs.camera;
      const canvasElement = self.$refs.canvas;
      const context = canvasElement.getContext("2d");

      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;
      context.drawImage(
        videoElement,
        -180, -650,
        1080,
        1980
      );

      setTimeout(() => {
        self.isShotPhoto = false;
        self.GotoFindingTenant();
        // this.downloadImage();
      }, FLASH_TIMEOUT);

    },

     async takePhotobast64(fromAuto = false) {
      let self = this;
      if (self.LoadingDialog || (self.isAutoCapturing && !fromAuto)) {
        return;
      }

      self.stopAutoCapture(false);
      self.isAutoCapturing = true;
      self.LoadingDialog = true;
      self.captureStatus = "*กำลังถ่ายรูป กรุณารอสักครู่";

      try {
        const base64 = await this.capturePersonBase64();

        this.isPhotoTaken = true;
        this.photoBase64 = base64;
        this.dataParam.image2 = base64.split(",")[1];

        setTimeout(() => {
          self.isShotPhoto = false;
          self.GotoFindingTenant();
        }, 700);
      } catch (error) {
        console.log(error);
        self.LoadingDialog = false;
        self.captureStatus = "*ไม่สามารถถ่ายรูปได้ กรุณาลองอีกครั้ง";
        self.resetAutoCaptureState();
        self.startAutoCapture();
      }
    },

      async capturePersonBase64() {
      if (this.imageCapture && this.imageCapture.takePhoto) {
        const blob = await this.imageCapture.takePhoto();
        return this.cropAndConvertToBase64(blob,900,900);
      }

      const video = this.$refs.camera;
      if (!video || !video.videoWidth || !video.videoHeight) {
        throw new Error("Camera is not ready");
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL("image/jpeg", 0.86);
    },

    startAutoCapture() {
      if (this.autoCaptureTimer || this.LoadingDialog || this.isPhotoTaken) {
        return;
      }

      this.autoCaptureTimer = setInterval(() => {
        this.scanPersonForAutoCapture();
      }, 200);
    },

    stopAutoCapture(clearState = true) {
      if (this.autoCaptureTimer) {
        clearInterval(this.autoCaptureTimer);
        this.autoCaptureTimer = null;
      }

      if (clearState) {
        this.resetAutoCaptureState();
      }
    },

    resetAutoCaptureState() {
      this.isAutoCapturing = false;
      this.isDetectingPerson = false;
    },

    async scanPersonForAutoCapture() {
      if (this.LoadingDialog || this.isPhotoTaken || this.isAutoCapturing || this.isDetectingPerson) {
        return;
      }

      const metrics = this.getPersonFrameMetrics();
      if (!metrics) {
        return;
      }

      this.isDetectingPerson = true;
      const faceDetected = await this.detectFaceInFrame();
      this.isDetectingPerson = false;

      const looksLikePerson =
        !this.faceDetector &&
        metrics.skinPixelRatio > 0.035 &&
        metrics.skinPixelRatio < 0.42 &&
        metrics.edgeScore > 5 &&
        metrics.brightness > 45 &&
        metrics.brightness < 220;

      if (faceDetected || looksLikePerson) {
        this.captureStatus = "*พบใบหน้าแล้ว กำลังถ่ายอัตโนมัติ";
        this.takePhotobast64(true);
      } else {
        this.captureStatus = "*กรุณาให้ใบหน้าอยู่ในกรอบ ระบบจะถ่ายอัตโนมัติ";
      }
    },

    async detectFaceInFrame() {
      if (!this.faceDetector || !this.autoCaptureCanvas) {
        return false;
      }

      try {
        const faces = await this.faceDetector.detect(this.autoCaptureCanvas);
        return faces && faces.length > 0;
      } catch (error) {
        this.faceDetector = null;
        return false;
      }
    },

    getPersonFrameMetrics() {
      const video = this.$refs.camera;
      if (!video || video.readyState < 2 || !video.videoWidth || !video.videoHeight) {
        return null;
      }

      const sampleWidth = 120;
      const sampleHeight = 100;
      const sourceWidth = video.videoWidth * 0.5;
      const sourceHeight = video.videoHeight * 0.78;
      const sourceX = (video.videoWidth - sourceWidth) / 2;
      const sourceY = video.videoHeight * 0.1;

      if (!this.autoCaptureCanvas) {
        this.autoCaptureCanvas = document.createElement("canvas");
        this.autoCaptureCanvas.width = sampleWidth;
        this.autoCaptureCanvas.height = sampleHeight;
      }

      const canvas = this.autoCaptureCanvas;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, sampleWidth, sampleHeight);

      const pixels = ctx.getImageData(0, 0, sampleWidth, sampleHeight).data;
      const gray = new Uint8Array(sampleWidth * sampleHeight);
      let sum = 0;
      let edgeTotal = 0;
      let edgeSamples = 0;
      let skinPixels = 0;

      for (let i = 0, j = 0; i < pixels.length; i += 4, j++) {
        const r = pixels[i];
        const g = pixels[i + 1];
        const b = pixels[i + 2];
        const value = Math.round(r * 0.299 + g * 0.587 + b * 0.114);
        gray[j] = value;
        sum += value;

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        if (r > 75 && g > 45 && b > 30 && max - min > 15 && r > g && g > b) {
          skinPixels++;
        }
      }

      for (let y = 1; y < sampleHeight; y += 2) {
        for (let x = 1; x < sampleWidth; x += 2) {
          const index = y * sampleWidth + x;
          edgeTotal +=
            Math.abs(gray[index] - gray[index - 1]) +
            Math.abs(gray[index] - gray[index - sampleWidth]);
          edgeSamples += 2;
        }
      }

      return {
        brightness: sum / gray.length,
        edgeScore: edgeTotal / edgeSamples,
        skinPixelRatio: skinPixels / gray.length,
      };
    },

      async cropAndConvertToBase64(blob, cropTop = 0, cropBottom = 0) {
      const imageBitmap = await createImageBitmap(blob);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // คำนวณขนาดภาพที่เหลือหลังตัด
      const safeCropTop = Math.min(cropTop, Math.floor(imageBitmap.height * 0.25));
      const safeCropBottom = Math.min(cropBottom, Math.floor(imageBitmap.height * 0.25));
      const cropHeight = imageBitmap.height - safeCropTop - safeCropBottom;

      // ตั้งขนาด canvas ใหม่
      canvas.width = imageBitmap.width;
      canvas.height = cropHeight;

      // วาดภาพเฉพาะส่วนที่ต้องการ (เริ่มจาก cropTop ลงมา)
      ctx.drawImage(
        imageBitmap,
        0, safeCropTop, imageBitmap.width, cropHeight, // ส่วนที่ตัดจากต้นฉบับ
        0, 0, imageBitmap.width, cropHeight        // วาดลงบน canvas
      );

      // แปลง canvas → base64
      return canvas.toDataURL("image/jpeg", 0.8); // 0.9 = คุณภาพ
    },
   

    downloadImage() {
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      // console.log(canvas);
      this.imageParam = canvas;
      this.dataParam.image2 = this.imageParam.split(",")[1];
    },

    GotoFindingTenant() {
      let self = this;
      // self.downloadImage();
      self.stopCameraStream();
      // self.$router.push("/FindingTenant");
      self.$router.push({
        name: "FindingTenant",
        path: "/FindingTenant",
        params: {
          data: self.dataParam,
        },
      });

    },

    BackToMain() {
      let self = this;
      self.stopCameraStream();
      self.$router.push("/MainMenu");
    },

    BacktoNationalIDCard() {
      let self = this;
      self.stopCameraStream();
      self.$router.push("/NationalIDCard");
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
.capture-person-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(14px, 2vh, 24px);
  padding: clamp(18px, 3vw, 40px);
}

.capture-person-page .capture-logo {
  width: min(28vw, 430px) !important;
  max-width: min(28vw, 430px) !important;
  margin: 0 !important;
}

.capture-person-page .capture-panel {
  width: min(1060px, calc(100vw - 160px)) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 160px);
  margin: 0 auto !important;
  padding: clamp(18px, 2.4vw, 34px) !important;
}

.capture-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(14px, 2vh, 22px);
}

.capture-header {
  text-align: center;
}

.capture-header h1 {
  color: #344054;
  font-size: clamp(34px, 3.2vw, 56px);
  font-weight: 800;
  line-height: 1.1;
  margin: 0;
}

.capture-header p {
  color: #667085;
  font-size: clamp(22px, 2vw, 34px);
  font-weight: 700;
  line-height: 1.2;
  margin: 8px 0 0;
}

.capture-header span {
  display: block;
  color: #344054;
  font-size: clamp(16px, 1.1vw, 20px);
  font-weight: 900;
  margin-top: 12px;
}

.capture-divider {
  width: min(520px, 44vw);
  margin: 14px auto 0;
  border-top-width: 7px !important;
  border-color: #344054 !important;
}

.camera-stage {
  display: flex;
  justify-content: center;
  width: 100%;
}

.capture-person-page .camera-container {
  width: min(48vw, 650px) !important;
  height: min(34vh, 360px) !important;
  min-height: 280px;
}

.capture-person-page video {
  width: 100% !important;
  height: 100% !important;
}

.person-frame {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  pointer-events: none;
}

.person-frame::before {
  content: "";
  position: absolute;
  top: 8%;
  left: 20%;
  width: 60%;
  height: 86%;
  border: 4px solid rgba(255, 255, 255, 0.86);
  border-radius: 999px 999px 42% 42%;
  box-shadow:
    0 0 0 9999px rgba(16, 24, 40, 0.18),
    inset 0 0 0 2px rgba(52, 64, 84, 0.22),
    0 12px 30px rgba(16, 24, 40, 0.18);
}

.person-head {
  width: min(11vw, 130px);
  height: min(11vw, 130px);
  max-height: 36%;
  border: 5px solid rgba(255, 255, 255, 0.94);
  border-radius: 50%;
  box-shadow:
    inset 0 0 0 2px rgba(52, 64, 84, 0.2),
    0 8px 18px rgba(16, 24, 40, 0.16);
  z-index: 1;
}

.person-shoulders {
  width: min(24vw, 280px);
  height: min(10vw, 118px);
  max-height: 28%;
  border: 5px solid rgba(255, 255, 255, 0.94);
  border-top: 0;
  border-radius: 0 0 999px 999px;
  box-shadow:
    inset 0 -2px 0 rgba(52, 64, 84, 0.18),
    0 8px 18px rgba(16, 24, 40, 0.14);
  z-index: 1;
}

.capture-actions {
  width: min(760px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: clamp(22px, 4vw, 56px);
}

.capture-button {
  width: 100% !important;
  min-height: 86px !important;
  background-color: #344054 !important;
}

.capture-button span {
  font-size: clamp(30px, 2.8vw, 44px);
  font-weight: 800;
}

.capture-button small {
  font-size: clamp(16px, 1.3vw, 24px);
  font-weight: 700;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.camera-container {
  position: relative;
  width: 640px;
  height: 480px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

</style>
